import Vue from "vue";

Vue.mixin({
    created() {
        this.$cache = {
        }
    },
});

export default null;